<template>
    <v-app>
        <navigation-bar></navigation-bar>
        <transition name="fade">
            <router-view class="router">
            </router-view>
        </transition>
        <v-fab-transition>
            <v-btn
                    v-show="!hiddenBtn"
                    style="background-color:rgba(5,146,201,1);"
                    fab
                    dark
                    bottom
                    right
                    fixed
                    class="mr-6 mb-6"
                    @click="$vuetify.goTo(0, { offset: -0 ,duration:1000 })"
            >
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-fab-transition>
            <FooterApp v-show="!hiddenBtn"></FooterApp>
        </v-fab-transition>
    </v-app>
</template>

<script>
    import NavigationBar from "./components/NavigationBar";
    import FooterApp from "./components/FooterApp";

    export default {
        name: 'App',
        data() {
            return {
                hiddenBtn: true,
            }
        },
        methods: {
            onScroll(e) {
                if (window.scrollY)
                    this.hiddenBtn = false
                else
                    this.hiddenBtn = true
            }
        },
        components: {
            FooterApp,
            NavigationBar,
        },
        created() {
            window.addEventListener('scroll', this.onScroll, {passive: true})
        },
        watch: {
            $route(to, from) {
                if (to !== from) {
                    this.$vuetify.goTo(0, {offset: -0, duration: 1000})
                }
            }
        }
    };
</script>
<style>
    html {
    }

    .router {
        margin: 0;
        padding: 0;
        margin-top: 48px !important;
        margin-bottom: 36px !important;
        min-height: calc(100vh - 84px) !important;
        width: 100vw !important;
    }

    .ludi-blue {
        background-color: rgba(5, 146, 201, 1) !important;
    }
</style>
